module.exports = __webpack_public_path__ + "static/media/thumbnail.4cb44d29.jpg";